import { Button, Group, Modal, Text } from '@mantine/core';

type ConfirmDeleteModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  error?: { message: string } | null;
  isLoading: boolean;
};

export default function ConfirmDeleteModal({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Delete',
  error,
  isLoading,
}: ConfirmDeleteModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Text mb="md">{message}</Text>
      {error && (
        <Text c="red" mb="md">
          {error.message ?? 'An error occurred'}
        </Text>
      )}
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm} loading={isLoading}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
